exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".RankingDashboardPanel-metricGroup-zZKjF{margin:0;padding:0;list-style:none}.RankingDashboardPanel-metricGroup-zZKjF>li{display:block;overflow:hidden;margin:10px 10px 10px 0}.RankingDashboardPanel-metricGroup-zZKjF>li .RankingDashboardPanel-container-2KVzm{display:block;overflow:hidden;margin:0;font-size:20px;font-weight:300}.RankingDashboardPanel-metricGroup-zZKjF>li .RankingDashboardPanel-container-2KVzm small{display:block;font-size:14px}.RankingDashboardPanel-metricGroup-zZKjF>li .RankingDashboardPanel-rank-3LC9d{display:block;float:left;min-width:20px;margin:2px 10px 0 0;padding:4px 0 2px;background:#a4b1b7;border-radius:9px;line-height:1;text-align:center;font-size:14px;font-weight:400}.RankingDashboardPanel-light-_ktk4 .RankingDashboardPanel-rank-3LC9d{color:#fff}", ""]);

// exports
exports.locals = {
	"metricGroup": "RankingDashboardPanel-metricGroup-zZKjF",
	"container": "RankingDashboardPanel-container-2KVzm",
	"rank": "RankingDashboardPanel-rank-3LC9d",
	"light": "RankingDashboardPanel-light-_ktk4"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/core/components/RankingDashboardPanel.less
// module id = 1655
// module chunks = 0